import React from 'react';
import { Dropdown } from 'antd';
import { MoreOutlined } from '@ant-design/icons';
import './InventoryCardDropdown.scss';

/**
 * InventoryCardDropdown Component
 *
 * Dropdown menu for card actions, triggered by the more icon (ellipsis)
 */
export const InventoryCardDropdown = ({ onIgnoreOptimizations, onMarkAsReady, className = '' }) => {
    const items = [
        {
            key: 'ignore-optimizations',
            label: 'Ignore Optimizations',
            onClick: onIgnoreOptimizations,
        },
        // {
        //     key: 'mark-as-ready',
        //     label: 'Mark as Ready',
        //     onClick: onMarkAsReady
        // }
    ];

    return (
        <Dropdown
            menu={{ items }}
            trigger={['click']}
            placement="bottomRight"
            className={className}
            classNames={{ root: 'rm-card-dropdown' }}
        >
            <MoreOutlined className="rm-card-more-icon" onClick={(e) => e.stopPropagation()} />
        </Dropdown>
    );
};

export default InventoryCardDropdown;
